import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';
import { Link } from "react-router-dom";



@inject('core')
@observer
export default class StoreButton extends React.Component {
	
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		const { core } = this.props
	}
	

	render() {
		const { core, store_id } = this.props
		const store = core.stores.find(s => s.store_id == store_id)
		if (!store) return <div>unknown store</div>

		return <div key={store.store_id} className="store-button">
			<Link to={'/' + core.pod_id + '/store/' + store_id}>{store.name}</Link> 
		</div>
	}

}
